import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'yt-fw-drop-down-control-buttons',
  templateUrl: './drop-down-control-buttons.component.html',
  styleUrls: ['./drop-down-control-buttons.component.scss']
})
export class DropDownControlButtonsComponent implements OnInit {
  @Output() onClear = new EventEmitter();
  @Output() onAdd = new EventEmitter();
  @Output() onTogglePicklist = new EventEmitter();
  @Output() onEdit = new EventEmitter();
  @Input() allowAddNew: boolean;
  @Input() isInvalid: boolean;
  @Input() isDisabled: boolean;
  @Input() TabStopOnButtons: boolean;
  @Input() ShowPicklistToggleButton: boolean = false;
  @Input() ShowClearButton: boolean = false;
  @Input() allowEdit: boolean;

  constructor() { }

  ngOnInit() {
  }

  onBtnClearClicked(){
    this.onClear.emit();
  }

  onBtnAddClicked(){
    this.onAdd.emit();
  }

  onBtnPicklistToggleClicked(){
    this.onTogglePicklist.emit();
  }

  onBtnEditClicked(){
    this.onEdit.emit();
  }

}
